module.exports = __webpack_public_path__ + "img/movers_thumbnail-400x300.63c463f2.jpg";